// Contractor credential wallet — types shared by the admin read-only
// surface (#307). Mirrors the backend `CredentialData` shape returned by
// `GET /contractors/:id/credentials`.

export type CredentialCategory =
  | 'OSHA'
  | 'LIFT'
  | 'FORKLIFT'
  | 'RIGGING'
  | 'MANUFACTURER'
  | 'UNION'
  | 'VENUE';

export type CredentialStatus = 'active' | 'expiring_soon' | 'expired';

export interface ContractorCredential {
  id: number;
  contractorId: number;
  category: CredentialCategory;
  name: string;
  issuer: string;
  expirationDate: string; // YYYY-MM-DD
  documentId: number | null;
  status: CredentialStatus;
  daysUntilExpiry: number;
  createdAt: string;
  updatedAt: string;
}

export const CATEGORY_ORDER: CredentialCategory[] = [
  'OSHA',
  'LIFT',
  'FORKLIFT',
  'RIGGING',
  'MANUFACTURER',
  'UNION',
  'VENUE',
];

export const CATEGORY_LABELS: Record<CredentialCategory, string> = {
  OSHA: 'OSHA',
  LIFT: 'Lift / Aerial',
  FORKLIFT: 'Forklift',
  RIGGING: 'Rigging',
  MANUFACTURER: 'Manufacturer training',
  UNION: 'Union / Local',
  VENUE: 'Venue-specific',
};
